import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { ReactComponent as ApparelIcon } from '../assets/apparel_24px.svg';

export function ShirtIncluded(props: { ShirtSize?: string; noText?: boolean }) {
  return (
    <Box sx={{ width: 'fit-content' }}>
      <Stack
        spacing={1}
        direction="row"
        alignItems="center"
        sx={{
          border: '1px solid #d32f2f44',
          backgroundColor: '#d32f2f11',
          color: '#d32f2f',
          borderRadius: 1,
          px: 1,
        }}
      >
        <ApparelIcon style={{ fill: '#d32f2f' }} />

        {props.ShirtSize ? (
          <Box
            sx={{ fontFamily: 'Roboto Mono', fontWeight: 'bold', fontSize: 18 }}
          >
            {props.ShirtSize}
          </Box>
        ) : null}

        {props.noText ? null : (
          <Box sx={{ fontFamily: 'Oswald', textTransform: 'uppercase' }}>
            shirt included
          </Box>
        )}
      </Stack>
    </Box>
  );
}
